<template>
  <main class="home-page-container">
    <h1 style="position: absolute; width: 1px; height: 1px; padding: 0; margin: -1px; overflow: hidden; clip: rect(0,0,0,0); border: 0;">KL06 Farm - Buy Fresh Fruits, Premium Spices, and Plants Online</h1>
    <PageLoader v-bind:storage="appLoading" />
    
    <!-- Hero Section -->
    <section class="hero-section">
      <Carousel />
    </section>

    <!-- Main Content Container -->
    <v-container class="px-4 px-md-10 py-0" fluid>
      <v-layout wrap justify-center>
        <v-flex xs12 lg11 xl10>
          
          <!-- Category Row 1: Fresh Fruit -->
          <section class="home-section mt-8">
            <ExclusiveProducts 
              v-bind:title="title" 
              v-bind:items="items2" 
              @stepper="winStepper" 
            />
          </section>

          <!-- Middle Banner / Trending -->
          <section class="home-section mt-12 mb-12">
            <TrendingProducts />
          </section>

          <!-- Category Row 2: Spices -->
          <section class="home-section">
            <ExclusiveProducts 
              v-bind:title="title2" 
              v-bind:items="items1"  
              @stepper="winStepper"
            />
          </section>

          <!-- Category Row 3: Plants -->
          <!-- <section class="home-section mb-16">
            <ExclusiveProducts 
              v-bind:title="title3" 
              v-bind:items="items2"  
              @stepper="winStepper"
            />
          </section> -->

        </v-flex>
      </v-layout>
    </v-container>
  </main>
</template>

<script>
import Carousel from "./carousel";
import ExclusiveProducts from "./exclusiveProducts";
import TrendingProducts from "./trendingProducts";
import axios from "axios";

export default {
  components: {
    Carousel,
    ExclusiveProducts,
    TrendingProducts,
  },
  props: ["storage"],
  data() {
    return {
      appLoading: false,
      title: "Fresh Fruit",
      title2: "Spices",
      title3: "Plants",
      items1: [],
      items2: [],
      guestId: null,
    };
  },
  beforeMount() {
    this.guestId = localStorage.getItem("guestId");
  },
  computed: {
    appLogin() {
      return this.$store.state.isLoggedIn;
    },
  },
  mounted() {
    this.setMetaTags();
    this.getData();
  },
  methods: {
    setMetaTags() {
      document.title = "KL-06 FARM | Fresh Fruits, Spices & Plants";
      const description = "Welcome to KL-06 FARM. Buy fresh, organic fruits, premium spices, and beautiful plants directly from our farm to your home.";
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        metaDescription = document.createElement('meta');
        metaDescription.name = 'description';
        metaDescription.content = description;
        document.head.appendChild(metaDescription);
      }
    },
    winStepper(item) {
      if (item.ref == "callgetdata") {
        if(item.getdata == true){
          this.getData();
        }
      }
    },
    getData() {
      this.appLoading = true;
      let headers1 = {};
      let data = {};
      
      if (this.appLogin) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        data["guestid"] = this.guestId;
      }

      axios({
        method: "get",
        url: "/view/maincategory/products",
        params: data,
        headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            if (response.data.data.length > 0) {
              this.items1 = response.data.data[0];
              this.items2 = response.data.data[1];
            }
          } else {
            this.items1 = [];
            this.items2 = [];
          }
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.home-page-container {
  background-color: #fafafa;
  min-height: 100vh;
}

.home-section {
  position: relative;
}

/* Smooth entry animation for sections */
.home-section {
  animation: fadeInUp 0.8s ease-out forwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .home-section {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
}
</style>